import { MouseEvent } from "react";

export const handleOuterClick = (
  e: MouseEvent<HTMLElement>,
  tr: HTMLTableRowElement,
  exitEdit: (dataItem: any) => void,
  dataItem: any
) => {
  const editRowClassName = "k-grid-edit-row";
  const isRowInEditState = tr.className.split(" ").includes(editRowClassName);
  if (!isRowInEditState) {
    return;
  }

  const { target } = e;
  const timeSelector = findAncestor(target, ".k-timeselector");
  if (timeSelector) {
    return;
  }

  exitEdit(dataItem);
};

function findAncestor(el: any, selector: string) {
  while (
    // eslint-disable-next-line no-cond-assign
    (el = el?.parentElement) &&
    !(el.matches || el.matchesSelector).call(el, selector)
  );
  return el;
}
